<app-confirm-dialog
  [visible]="confirmationDialogVisible"
  variant="secondary"
  heading="Confirmation"
  [message]="confirmationDialogMessage"
  cancelText="No"
  (confirmed)="confirmConfirmationDialog()"
  (cancelled)="cancelConfirmationDialog()">
</app-confirm-dialog>
<div class="add-package-builder-responsive card card-w-title" style="text-align: center;">
  <p-steps [model]="items" [(activeIndex)]="activeIndex" [readonly]="true" class=" p-steps-tecfolk-fix"></p-steps>
  <div class="package-main-div card card-w-title" *ngIf="activeIndex == 0">
    <div class="p-g-12 p-md-6 p-lg-4 task-list package-card-tecfolk-fix">
      <p-panel [header]='setLabel("monthWisePackageHeaderLabel")' [style]="{'backgroundColor': '#fad8bc'}">
        <img src="assets/demo/gymLogo/monthly.png" style="height: 80px;">
        <div class="p-panel-content p-widget-content" style="height:200px">
          <ul class="signupMembershipCard pl-0">
            <li>{{setLabel("aDiscounted,month-by-month")}}</li><!-- <li>RS <b>3500</b><small>/Mo</small></li> -->
            <li>{{setLabel("membershipHomeClub!Label")}}</li>
            <li style="margin-top: 50px;">
              <div class="nextBtn">
                <button id="loginbtn" [disabled]="loading" (click)="selectSubcription('Month Wise Package')"
                  class="p-g-6 p-lg-4 p-button p-widget p-state-default p-corner-all">
                  <span class="p-button-text p-c">{{setLabel("nextBtnLabel")}}</span>
                  <span *ngIf="loading" class="p-button-icon-left p-c fa fa-spinner fa-spin"
                    style="font-size:24px"></span>
                </button>
              </div>
            </li>
          </ul>
        </div>
      </p-panel>
    </div>
    <div class="p-g-12 p-md-6 p-lg-4 task-list package-card-tecfolk-fix">
      <p-panel [header]='setLabel("personWisePackageHeaderLabel")' [style]="{'backgroundColor': '#e7f4cf'}">
        <img src="assets/demo/gymLogo/group.png" style="height: 80px;">
        <div class="p-panel-content p-widget-content" style="height:200px">
          <ul class="signupMembershipCard pl-0">
            <!-- <li>RS <b>4000</b><small>/Mo</small></li> -->
            <li>{{setLabel("aDiscounted,Person-By-PersonLabel")}}</li>
            <li> {{setLabel("membershipHomeClub!Label")}}</li>
            <!-- <li>PERFECT FOR BEGINERS !</li> -->
            <li style="margin-top: 50px;">
              <div class="nextBtn">
                <button id="loginbtn" [disabled]="loading" (click)="selectSubcription('Person Wise Package')"
                  class="p-g-6 p-lg-4 p-button p-widget p-state-default p-corner-all">
                  <span class="p-button-text p-c">{{setLabel("nextBtnLabel")}}</span>
                  <span *ngIf="loading" class="p-button-icon-left p-c fa fa-spinner fa-spin"
                    style="font-size:24px"></span>
                </button>
              </div>

            </li>
          </ul>
        </div>
      </p-panel>
    </div>
    <div class="p-g-12 p-md-6 p-lg-4 task-list package-card-tecfolk-fix">
      <p-panel header='Duplicate Pacakage' [style]="{'backgroundColor': '#e7f4cf'}">
        <img src="assets/demo/gymLogo/effort.png" style="height: 80px;">
        <div class="p-panel-content p-widget-content" style="height:200px">
          <ul class="signupMembershipCard pl-0">
            <li>Packages can be duplicated</li>
            <li>Best for repetative packages</li>
            <li style="margin-top: 50px;">
              <div class="nextBtn">
                <button id="loginbtn" [disabled]="loading" (click)="selectSubcription('Duplicate Package')"
                  class="p-g-6 p-lg-4 p-button p-widget p-state-default p-corner-all">
                  <span class="p-button-text p-c">{{setLabel("nextBtnLabel")}}</span>
                  <span *ngIf="loading" class="p-button-icon-left p-c fa fa-spinner fa-spin"
                    style="font-size:24px"></span>
                </button>
              </div>
            </li>
          </ul>
        </div>
      </p-panel>
    </div>


    <!-- <div class="p-g-12 p-md-6 p-lg-4 task-list package-card-tecfolk-fix">
      <p-panel header="Company Package" [style]="{'backgroundColor': '#fad8bc'}">
        <img src="assets/demo/gymLogo/corporate.png" style="height: 80px;">
        <div class="p-panel-content p-widget-content" style="height:200px">
          <ul class="signupMembershipCard pl-0">
            <li>A big benefit for your business.</li>
            <li> Whether you’re looking to cover all of the membership cost for your team!</li>
            <li style="margin-top: 26px;">
              <button id="loginbtn" [disabled]="loading" (click)="selectSubcription('Company Package')"
                class="p-button p-widget p-state-default p-corner-all">
                <span class="p-button-text p-c">Next</span>
                <span *ngIf="loading" class="p-button-icon-left p-c fa fa-spinner fa-spin"
                  style="font-size:24px"></span>
              </button>
            </li>
          </ul>
        </div>
      </p-panel>
    </div> -->
    <div style="clear: both;"></div>
  </div>
  <div class="card card-w-title" *ngIf="activeIndex == 1">
    <div class="p-g-12">
      <form #memberSignUpForm="ngForm">
        <div class="p-g-12">
          <!-- <button id="loginbtn" [disabled]="loading" (click)="reverse()"
            class="p-button p-widget p-state-default p-corner-all">
            <span class="p-button-text p-c">Back</span>
            <span *ngIf="loading" class="p-button-icon-left p-c fa fa-spinner fa-spin" style="font-size:24px"></span>
          </button>&nbsp;&nbsp; -->

        </div>
        <div class="p-g-12 p-md-6" style="text-align: left">
          <h3 class="main-heading first">{{setLabel("packageBuilderDetailsLabel")}}</h3>
          <div class="p-g p-fluid">
            <div class="p-g-12">
              <h3 class="first">{{setLabel("packageName:Label")}} <span style="color: red;">*</span>&nbsp;&nbsp;</h3>
              <div class="p-inputgroup">
                <span class="p-inputgroup-addon"><i class="fa fa-user" aria-hidden="true"></i></span>
                <input autocomplete="off" pattern="[A-Za-z ]+"
                  [ngClass]="packageName.invalid && (packageName.dirty || packageName.touched) ? 'errorInput' : '' "
                  type="text" pInputText [placeholder]='setLabel("name*PlaceholderLabel")' #packageName="ngModel" name="name" required
                  [(ngModel)]="package.packageName">
              </div>
              <div *ngIf="packageName.invalid && (packageName.dirty || packageName.touched)">
                <div *ngIf="packageName.errors.required" class="errorShow">
                  {{setLabel("nameRequiredErrorLabel")}}
                </div>
                <div *ngIf="packageName.errors.pattern" class="errorShow">
                  {{setLabel("charactersAllowedErrorLabel")}}
                </div>
              </div>
            </div>
            <!-- <h3 class="first">Joining Date</h3>
            <div class="p-g-12">
              <p-calendar [yearNavigator]="true" yearRange="1950:2040" [monthNavigator]="true"
                [(ngModel)]="member.joiningDate" placeholder="Joining Date" name="joinDate" [inline]="false"
                dateFormat="dd/mm/yy" [showIcon]="true">
              </p-calendar>
            </div>
            <h3 class="first">Date Of Birth</h3>
            <div class="p-g-12">
              <p-calendar [yearNavigator]="true" yearRange="1950:2040" [monthNavigator]="true"
                [(ngModel)]="member.dateOfBirth" placeholder="Date Of Birth" name="dateOfBirth" [inline]="false"
                dateFormat="dd/mm/yy" [showIcon]="true">
              </p-calendar>
            </div> -->
            <div class="p-g-12">
              <div class="p-g">
                <h3 class="first">{{setLabel("packageTypeLabel")}}</h3>
                <div class="p-g-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon"><i class="fa fa-money" aria-hidden="true"></i></span>
                    <input type="text" required #packageType="ngModel" pattern="[0-9]+" autocomplete="off"
                      [disabled]="true"
                      [ngClass]="packageType.invalid && (packageType.dirty || packageType.touched) ? 'errorInput' : '' "
                      [placeholder]='setLabel("packageType*PlaceholderLabel")' pInputText name="packageType" [(ngModel)]="package.packageType">
                  </div>
                  <div *ngIf="packageType.invalid && (packageType.dirty || packageType.touched)">
                    <div *ngIf="packageType.errors.required" class="errorShow">
                      {{setLabel("packageTypeFeeRequiredErrorLabel")}}
                    </div>
                    <div *ngIf="packageType.errors.pattern" class="errorShow">
                      {{setLabel("numbersAllowedErrorLabel")}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="p-g-12">
              <div class="p-g">
                <!-- <h3 class="first">Logo</h3>
                <div class="p-g-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon"><i class="fa fa-money" aria-hidden="true"></i></span>
                    <input type="text" required #logo="ngModel" pattern="[0-9]+" autocomplete="off"
                      [ngClass]="logo.invalid && (logo.dirty || logo.touched) ? 'errorInput' : '' " placeholder="logo *"
                      pInputText name="logo" [(ngModel)]="package.logo">
                  </div>
                  <div *ngIf="logo.invalid && (logo.dirty || logo.touched)">
                    <div *ngIf="logo.errors.required" class="errorShow">
                      logo is required.
                    </div>
                    <div *ngIf="logo.errors.pattern" class="errorShow">
                      Only Numbers are allowed.
                    </div>
                  </div>
                </div> -->
                <div class="p-g-12">
                  <div class="p-g">
                    <h3>{{setLabel("logoLabel")}}</h3>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <p-listbox [options]="packagesLogo" [style]="{'width': '160%'}" required [(ngModel)]="selectedLogo"
                      [ngModelOptions]="{standalone: true}" [listStyle]="{'max-height':'250px'}">
                      <ng-template let-logo pTemplate="item">
                        <div class="p-helper-clearfix">
                          <img src="assets/demo/gymLogo/{{logo.value}}.png"
                            style="display:inline-block;margin:5px 0 0 5px" width="48">
                          <span style="float:right;margin:20px 10px 0 20px">{{logo.label}}</span>
                        </div>
                      </ng-template>
                      <p-footer>
                        {{setLabel("selected:Label")}} {{selectedLogo ||'none'}}
                      </p-footer>
                    </p-listbox>
                  </div>
                </div>
              </div>
            </div>
            <div class="p-g-12">
              <div class="p-g">
                <h3 class="first">{{setLabel("packageColorLabel")}}</h3>
                <div class="p-g-12">
                  <div class="package-color p-inputgroup">
                    <!-- <span class="p-inputgroup-addon"><i class="fa fa-money" aria-hidden="true"></i></span> -->
                    <!-- <input type="text" required #color="ngModel" pattern="[0-9]+" autocomplete="off"
                      [ngClass]="color.invalid && (color.dirty || color.touched) ? 'errorInput' : '' "
                      placeholder="color *" pInputText name="logo" [(ngModel)]="package.color"> -->
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <p-colorPicker name="color" required #color="ngModel" [inline]="true" [(ngModel)]="package.color">
                    </p-colorPicker>&nbsp;&nbsp;&nbsp;
                    <!-- <p style="margin-top:.5em">{{setLabel("packageColor")}} <span>{{package.color}}</span></p> -->
                  <span [style.background-color]="package.color" style="width: 15rem;height: 10rem;border-radius: 0.8rem;"></span>
                  </div>
                  <div *ngIf="color.invalid && (color.dirty || color.touched)">
                    <div *ngIf="color.errors.required" class="errorShow">
                     {{setLabel("colorrequiredErrorLabel")}}
                    </div>
                    <div *ngIf="color.errors.pattern" class="errorShow">
                      {{setLabel("numbersAllowedErrorLabel")}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="p-g-12">
              <div class="p-g">
                <h3 class="first">{{setLabel("descriptionLabel")}}</h3>
                <div class="p-g-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon"><i class="fa fa-money" aria-hidden="true"></i></span>
                    <textarea type="text" #description="ngModel" style="width: 100% !important;" autocomplete="off"
                     [placeholder]='setLabel("description*PlaceholderLabel")' pInputText name="description"
                      [(ngModel)]="package.description"></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="p-g-12 p-md-6" style="text-align: left">
          <br>
          <br>
          <br>
          <div class="p-g p-fluid">
            <div class="p-g-12">
              <h3 class="first">{{setLabel("sequenceNo:Label")}}<span style="color: red;">*</span>&nbsp;&nbsp;</h3>
              <div class="p-inputgroup">
                <span class="p-inputgroup-addon"><i class="fa fa-user" aria-hidden="true"></i></span>
                <input autocomplete="off" pattern="[0-9]+"
                  [ngClass]="sn.invalid && (sn.dirty || sn.touched) ? 'errorInput' : '' " type="number" pInputText
                  [placeholder]='setLabel("sequenceNo*PlaceholderLabel")' #sn="ngModel" name="sn" required [(ngModel)]="package.sn">
              </div>
              <div *ngIf="sn.invalid && (sn.dirty || sn.touched)">
                <div *ngIf="sn.errors.required" class="errorShow">
                  {{setLabel("sNRequiredErrorLabel")}}
                </div>
                <div *ngIf="sn.errors.pattern" class="errorShow">
                  {{setLabel("numbersAllowedErrorLabel")}}
                </div>
              </div>
              <br>
            </div>
            <div class="p-g-12">
              <h3 class="first">{{setLabel("noOfMembersLabel")}}</h3>
              <div class="p-inputgroup">
                <span class="p-inputgroup-addon"><i class="fa fa-user" aria-hidden="true"></i></span>
                <input autocomplete="off" [disabled]="isMonthWisePackage" pattern="[0-9]+"
                  [ngClass]="noOfMembers.invalid && (noOfMembers.dirty || noOfMembers.touched) ? 'errorInput' : '' "
                  type="text" pInputText [placeholder]='setLabel("noOfMembers*PlaceholderLabel")' #noOfMembers="ngModel" name="noOfMembers" required
                  [(ngModel)]="package.noOfMembers">
              </div>
              <div *ngIf="noOfMembers.invalid && (noOfMembers.dirty || noOfMembers.touched)">
                <div *ngIf="noOfMembers.errors.required" class="errorShow">
                  {{setLabel("noOfMembersRequiredErrorLabel")}}
                </div>
                <div *ngIf="noOfMembers.errors.pattern" class="errorShow">
                 {{setLabel("numbersAllowedErrorLabel")}}
                </div>
              </div>
              <br>
              <div class="p-inputgroup" *ngIf="isPersonWisePackage">
                <span class="p-inputgroup-addon"><i class="fa fa-check-square-o" aria-hidden="true"></i></span>
                <p-checkbox name="isGreaterthanNoOfMembers" [(ngModel)]="package.isGreaterthanNoOfMembers" binary="true"
                  inputId="binary"></p-checkbox> &nbsp; {{setLabel("isMoreThanLabel")}}
              </div>
            </div>
<div class="p-g-12">
              <div class="p-g">
                <h3 class="first">{{setLabel("registrationFeeLabel")}}</h3>
                <div class="p-g-12">
                  <!-- <div class="p-inputgroup">
                    <span class="p-inputgroup-addon"><i class="fa fa-money" aria-hidden="true"></i></span>
                    <p-dropdown [options]="packageRegFeePersonWiseTypes" name="packageRegFeePersonWiseTypes"
                      [style]="{'width':'100%'}" required [(ngModel)]="package.packageRegFeeType">
                    </p-dropdown>
                  </div> -->
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon"><i class="fa fa-money" aria-hidden="true"></i></span>
                    <input type="number" min="0" required #registerationFee="ngModel" pattern="[0-9]+" autocomplete="off"
                      [ngClass]="registerationFee.invalid && (registerationFee.dirty || registerationFee.touched) ? 'errorInput' : '' "
                      [placeholder]='setLabel("registrationFeePKR*PlaceholderLabel")' pInputText name="registerNumber"
                      [(ngModel)]="package.registerationFee"
                      (focus)="package.registerationFee == 0 ? package.registerationFee = null : null"
                      (blur)="package.registerationFee == null || package.registerationFee === '' ? package.registerationFee = 0 : null">
                  </div>
                  <div *ngIf="registerationFee.invalid && (registerationFee.dirty || registerationFee.touched)">
                    <div *ngIf="registerationFee.errors.required" class="errorShow">
                      {{setLabel("registerationFeeRequiredErrorLabel")}}
                    </div>
                    <div *ngIf="registerationFee.errors.pattern" class="errorShow">
                      {{setLabel("numbersAllowedErrorLabel")}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="p-g-12">
              <div class="p-g">
                <h3 class="first">{{setLabel("packageFeeLabel")}}</h3>
                <div class="p-g-12">
                  <!-- <div class="p-inputgroup" *ngIf="isMonthWisePackage">
                    <span class="p-inputgroup-addon"><i class="fa fa-money" aria-hidden="true"></i></span>
                    <p-dropdown [options]="packageFeeTypes" name="packageFeeType" [style]="{'width':'100%'}" required
                      [(ngModel)]="package.packageFeeType">
                    </p-dropdown>
                  </div> -->
                  <!-- <div class="p-inputgroup" *ngIf="!isMonthWisePackage">
                    <span class="p-inputgroup-addon"><i class="fa fa-money" aria-hidden="true"></i></span>
                    <p-dropdown [options]="packageFeePersonWiseTypes" name="packageFeeType" [style]="{'width':'100%'}"
                      required [(ngModel)]="packageFeeType">
                    </p-dropdown>
                  </div> -->
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon"><i class="fa fa-money" aria-hidden="true"></i></span>
                    <input type="number" min="0" pattern="[0-9]+" autocomplete="off"
                      [ngClass]="packageFee.invalid && (packageFee.dirty || packageFee.touched) ? 'errorInput' : '' "
                      required #packageFee="ngModel" [placeholder]='setLabel("monthlyFeePKR*PlaceholderLabel")' pInputText name="packageFee"
                      [(ngModel)]="package.packageFee"
                      (focus)="package.packageFee == 0 ? package.packageFee = null : null"
                      (blur)="package.packageFee == null || package.packageFee === '' ? package.packageFee = 0 : null">
                  </div>
                  <div *ngIf="packageFee.invalid && (packageFee.dirty || packageFee.touched)">
                    <div *ngIf="packageFee.errors.required" class="errorShow">
                      {{setLabel("packageFeeCorrectlyErrorLabel")}}
                    </div>
                    <div *ngIf="packageFee.errors.pattern" class="errorShow">
                      {{setLabel("numbersAllowedErrorLabel")}}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="p-g-12">
              <div class="p-g">
                <h3 class="first">{{setLabel("packageDurationLabel")}}</h3>
                <div class="p-g-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon"><i class="fa fa-hourglass-start" aria-hidden="true"></i></span>
                    <p-dropdown [options]="packageDurationTypes" name="packageDurationType" [style]="{'width':'100%'}"
                      required [(ngModel)]="packageDurationType">
                    </p-dropdown>
                  </div>
                </div>
              </div>
            </div>
            <div class="p-g-12" *ngIf="packageDurationType == 'months' ">
              <div class="p-g">
                <h3 class="first">{{setLabel("noOfMonthLabel")}}</h3>
                <div class="p-g-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon"><i class="fa fa-hourglass-start" aria-hidden="true"></i></span>
                    <input type="number" required #noOfMonths="ngModel" pattern="[0-9]+" min="1" autocomplete="off"
                      [ngClass]="noOfMonths.invalid && (noOfMonths.dirty || noOfMonths.touched) ? 'errorInput' : '' "
                      [placeholder]='setLabel("noOfMonth(s)*PlaceholderLabel")' pInputText name="noOfMonths" [(ngModel)]="package.noOfMonths">
                  </div>
                  <div *ngIf="noOfMonths.invalid && (noOfMonths.dirty || noOfMonths.touched)">
                    <div *ngIf="noOfMonths.errors.required" class="errorShow">
                      {{setLabel("noOfMonthRequiredErrorLabel")}}
                    </div>
                  <div *ngIf="noOfMonths.errors.min && !noOfMonths.errors.pattern" class="errorShow">
                      {{setLabel("numbersAllowedErrorLabel")}}
                    </div>
                    <div *ngIf="noOfMonths.errors.min" class="errorShow">
                      Value cannot be 0
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="p-g-12" *ngIf="packageDurationType === 'weeks' ">
              <div class="p-g">
                <h3 class="first">{{setLabel("noOfWeekLabel")}}</h3>
                <div class="p-g-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon"><i class="fa fa-hourglass-start" aria-hidden="true"></i></span>
                    <input type="number" required #noOfWeeks="ngModel" pattern="[0-9]+" min="1" autocomplete="off"
                      [ngClass]="noOfWeeks.invalid && (noOfWeeks.dirty || noOfWeeks.touched) ? 'errorInput' : '' "
                     placeholder='No of weeks' pInputText name="noOfWeeks" [(ngModel)]="package.noOfWeeks">
                  </div>
                  <div *ngIf="noOfWeeks.invalid && (noOfWeeks.dirty || noOfWeeks.touched)">
                    <div *ngIf="noOfWeeks.errors.required" class="errorShow">
                      No of Weeks are required
                    </div>
                    <div *ngIf="noOfWeeks.errors.pattern" class="errorShow">
                      No of Weeks error
                    </div>
                    <div *ngIf="noOfWeeks.errors.min" class="errorShow">
                      Value cannot be 0
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="p-g-12" *ngIf="packageDurationType === 'days' ">
              <div class="p-g">
                <h3 class="first">{{setLabel("noOfDaysLabel")}}</h3>
                <div class="p-g-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon"><i class="fa fa-hourglass-start" aria-hidden="true"></i></span>
                    <input type="number" required #noOfDays="ngModel" pattern="[0-9]+" min="1" autocomplete="off"
                      [ngClass]="noOfDays.invalid && (noOfDays.dirty || noOfDays.touched) ? 'errorInput' : '' "
                     placeholder='No of Days' pInputText name="noOfDays" [(ngModel)]="package.noOfDays">
                  </div>
                  <div *ngIf="noOfDays.invalid && (noOfDays.dirty || noOfDays.touched)">
                    <div *ngIf="noOfDays.errors.required" class="errorShow">
                      No of Days are required
                    </div>
                    <div *ngIf="noOfDays.errors.pattern" class="errorShow">
                      No of Days error
                    </div>
                    <div *ngIf="noOfDays.errors.min" class="errorShow">
                      Value cannot be 0
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="p-g-12">
              <div class="p-g">
                <h3 class="first">{{setLabel("ageGroupLabel")}}&nbsp;</h3>
                <div class="p-g-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">{{setLabel("fromLabel")}}</span>
                    <input type="number" min="0" #ageFrom="ngModel" pattern="[0-9]+" autocomplete="off"
                      [ngClass]="ageFrom.invalid && (ageFrom.dirty || ageFrom.touched) ? 'errorInput' : ''"
                      placeholder='Age From' pInputText name="ageFrom"
                      [(ngModel)]="package.ageGroupFrom">
                  </div>
                    <div *ngIf="ageFrom.invalid && (ageFrom.dirty || ageFrom.touched)">
    <div *ngIf="ageFrom.errors?.min || ageFrom.errors?.pattern" class="errorShow">
      Age From must be zero or greater.
    </div>
  </div>
                </div>
              <div class="p-g-12">
  <div class="p-inputgroup">
    <span class="p-inputgroup-addon">{{setLabel("toLabel")}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
    <input type="number" min="0" #ageTo="ngModel" pattern="[0-9]+" autocomplete="off"
      [ngClass]="ageTo.invalid && (ageTo.dirty || ageTo.touched) ? 'errorInput' : ''"
      placeholder='Age To' pInputText name="ageTo"
      [(ngModel)]="package.ageGroupTo">
  </div>

  <div *ngIf="ageTo.invalid && (ageTo.dirty || ageTo.touched)">
    <div *ngIf="ageTo.errors?.min || ageTo.errors?.pattern" class="errorShow">
      Age To must be zero or greater.
    </div>
  </div>
  <div *ngIf="package.ageGroupFrom != null &&
            package.ageGroupTo != null &&
            +package.ageGroupFrom >= 0 &&
            +package.ageGroupTo >= 0 &&
            +package.ageGroupFrom > +package.ageGroupTo"
     class="errorShow">
  Age To must be greater than or equal to Age From.
</div>
</div>
                <div *ngIf="branch.permissions?.complimentaryFreezingDays">
                  <h3 class="first">{{setLabel("complimentaryFreezingDaysLabel")}}&nbsp;</h3>
                  <div class="p-g-12">
                    <div class="p-inputgroup">
                      <span class="p-inputgroup-addon">{{setLabel("freezingDaysLabel")}}</span>
                     <input type="number" min="0" #freezingDays="ngModel" pattern="[0-9]+" autocomplete="off"
  [ngClass]="freezingDays.invalid && (freezingDays.dirty || freezingDays.touched) ? 'errorInput' : ''"
  placeholder='Freezing Days' pInputText name="freezingDays"
  [(ngModel)]="package.freezingDays">
</div>

<div *ngIf="freezingDays.invalid && (freezingDays.dirty || freezingDays.touched)">
  <div *ngIf="freezingDays.errors?.min || freezingDays.errors?.pattern" class="errorShow">
    Freezing Days must be zero or greater.
  </div>
</div>
                  </div>
                </div>
                <div class="p-g-12" *ngIf="isPersonWisePackage">
                  <div class="p-g">
                    <h3 class="first">{{setLabel("feecollectionSettingsLabel")}}</h3>
                    <div class="p-g-12">
                      <div class="p-inputgroup">
                        <label class="checkboxCustomStyle" [ngClass]="{'selected': groupFeePayByOnePerson}" for="groupFeePayByOnePerson" (click)="toggleGroupFeePayByOnePerson()">
                          <span>{{setLabel("onePersoncanpayfeeofwholepackageLabel")}}</span>
                        </label>
                      </div>
                      <p class="fee-setting-desc" *ngIf="groupFeePayByOnePerson">{{setLabel("onePersonPayFeeDescLabel")}}</p>
                    </div>
                    <div class="p-g-12" *ngIf="showSameHistoryOption()">
                      <div class="p-inputgroup">
                        <label class="checkboxCustomStyle" [ngClass]="{'selected': sameHistory}" for="sameHistory" (click)="toggleSameHistory()">
                          <span>{{setLabel("sameHistoryLabel")}}</span>
                        </label>
                      </div>
                      <p class="fee-setting-desc">{{setLabel("sameHistoryDescLabel")}}</p>
                    </div>
                    <div class="p-g-12" *ngIf="groupFeePayByOnePerson">
                      <label class="fee-ack-checkbox-label">
                        <input type="checkbox" name="hasReadFeeCollectionDesc"
                          [(ngModel)]="hasReadFeeCollectionDesc" />
                        <span>{{setLabel("iHaveReadFeeCollectionDescLabel")}}</span>
                      </label>
                      <small *ngIf="!hasReadFeeCollectionDesc" class="errorShow">{{setLabel("feeCollectionDescRequiredErrorLabel")}}</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="p-g-12" *ngIf="!isCompanyWisePackage">
              <div class="p-g">
                <h3 class="first">{{setLabel("contactPersonLabel")}}</h3>
                <div class="p-g-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon"><i class="fa fa-location-arrow" aria-hidden="true"></i></span>
                    <input type="text" autocomplete="off" pInputText [placeholder]='setLabel("namePlaceholderLabel")' name="name"
                      [(ngModel)]="package.companyContactPerson.name">
                  </div>
                </div>
                <div class="p-g-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon"><i class="fa fa-map-marker" aria-hidden="true"></i></span>
                    <input type="email" autocomplete="off" pInputText [placeholder]='setLabel("emailPlaceholderLabel")' name="email"
                      [(ngModel)]="package.companyContactPerson.email">
                  </div>
                </div>
                <div class="p-g-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon"><i class="fa fa-map-marker" aria-hidden="true"></i></span>
                    <input type="text" autocomplete="off" pInputText [placeholder]='setLabel("contactNoPlaceholderLabel")' name="contactNo"
                      [(ngModel)]="package.companyContactPerson.contactNo">
                  </div>
                </div>
                <div class="p-g-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon"><i class="fa fa-map-marker" aria-hidden="true"></i></span>
                    <input type="text" autocomplete="off" pInputText [placeholder]='setLabel("officeContactNoPlaceholderLabel")'
                      name="officeContactNo" [(ngModel)]="package.companyContactPerson.officeContactNo">
                  </div>
                </div>
                <div class="p-g-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon"><i class="fa fa-address-book-o" aria-hidden="true"></i></span>
                    <input type="text" autocomplete="off" pInputText [placeholder]='setLabel("officeAddressPlaceholderLabel")' name="officeAddress"
                      [(ngModel)]="package.companyContactPerson.officeAddress">
                  </div>
                </div>
              </div>
            </div> -->

          </div>
        </div>

      </form>

      <!-- Always allowed zones + optional time schedules -->
      <div class="card card-w-title" *ngIf="zones && zones.length > 0" style="margin: 0 -1rem;">
        <div class="p-g-12">
          <div class="actMainHeading">
            <h3 class="main-heading first" [ngClass]="{'zone-selection-warning': zoneSaveTouched && hasZoneSelectionError()}">
              {{setLabel("ACTLabel")}}
              <span *ngIf="!isTimeBased" style="color: red;">*</span>
            </h3>
          </div>
          <div *ngIf="isTimeBased" class="always-allowed-hint">{{setLabel('alwaysAllowedZonesHintLabel')}}</div>
          <div class="day-chip-row always-allowed-zones">
            <button type="button" class="zone-chip zone-chip-always"
              *ngFor="let zone of zones; let i = index"
              [class.selected]="zone.IsSelect == 1"
              (click)="updateZoneSelection(!(zone.IsSelect == 1), i)">
              {{ zone.ZoneName }}
            </button>
          </div>
          <div *ngIf="zoneSaveTouched && hasZoneSelectionError()" class="errorShow" style="display: block; text-align: left;">
            {{setLabel('selectAtLeastOneZoneErrorLabel')}}
          </div>

          <div class="p-g-12" style="margin-top: 1.5rem; text-align: left;"
            *ngIf="branch?.permissions?.timeBasedPackages">
            <label class="checkboxCustomStyle" [ngClass]="{'selected': isTimeBased}"
              (click)="onTimeBasedToggle(!isTimeBased)">
              <span>{{setLabel('isTimeBasedLabel')}}</span>
            </label>
          </div>

          <div *ngIf="branch?.permissions?.timeBasedPackages && isTimeBased"
            class="p-g-12 time-based-section" style="text-align: left;">
            <div class="time-schedules-heading">{{setLabel('timeSchedulesSectionLabel')}}</div>
            <div class="time-based-help">
              <div class="time-based-help-title">{{setLabel('timeBasedScenariosTitleLabel')}}</div>
              <div class="time-based-help-item">{{setLabel('timeBasedScenarioAllowOnlyLabel')}}</div>
              <div class="time-based-help-item">{{setLabel('timeBasedScenarioDenyWindowLabel')}}</div>
            </div>

            <div class="exception-live-desc exception-live-desc-combined">
              <div class="exception-live-desc-title">{{setLabel('accessWindowCombinedDescTitleLabel')}}</div>
              <div class="exception-live-desc-text">{{ getCombinedAccessWindowsDescription() }}</div>
            </div>

            <div class="exception-row" *ngFor="let row of exceptionRows; let rowIndex = index">
              <div class="exception-row-header">
                <div class="exception-row-title">
                  <span class="exception-row-index">{{ rowIndex + 1 }}</span>
                  <h3 class="first">{{ getExceptionRowTitle(row, rowIndex) }}</h3>
                </div>
                <button type="button" class="p-button p-button-danger exception-remove-btn"
                  *ngIf="exceptionRows.length > 1"
                  (click)="removeExceptionRow(rowIndex)">
                  {{setLabel('removeExceptionBtnLabel')}}
                </button>
              </div>

              <div class="exception-meta-grid">
                <div class="exception-label-field">
                  <label class="exception-field-label">{{setLabel('exceptionNameLabel')}} <span class="required-star">*</span></label>
                  <div class="p-inputgroup exception-label-input">
                    <span class="p-inputgroup-addon"><i class="fa fa-tag" aria-hidden="true"></i></span>
                    <input type="text" pInputText maxlength="80"
                      [placeholder]="setLabel('exceptionNamePlaceholderLabel')"
                      [ngModelOptions]="{standalone: true}"
                      [(ngModel)]="row.label" />
                  </div>
                </div>

                <div class="time-fields-row">
                  <div class="time-field">
                    <label class="exception-field-label">{{setLabel('exceptionStartTimeLabel')}} <span class="required-star">*</span></label>
                    <p-calendar class="time-calendar" [ngModelOptions]="{standalone: true}" [(ngModel)]="row.startTime"
                      [hourFormat]="24" [timeOnly]="true" [showIcon]="true" [style]="{'width':'150px'}">
                    </p-calendar>
                  </div>
                  <div class="time-field">
                    <label class="exception-field-label">{{setLabel('exceptionEndTimeLabel')}} <span class="required-star">*</span></label>
                    <p-calendar class="time-calendar" [ngModelOptions]="{standalone: true}" [(ngModel)]="row.endTime"
                      [hourFormat]="24" [timeOnly]="true" [showIcon]="true" [style]="{'width':'150px'}">
                    </p-calendar>
                  </div>
                </div>
              </div>

              <div class="exception-section">
                <label class="exception-field-label">{{setLabel('exceptionDaysLabel')}}</label>
                <div class="day-chip-row">
                  <button type="button" class="day-chip"
                    *ngFor="let day of daysOfWeekOptions"
                    [class.selected]="isExceptionDaySelected(rowIndex, day.value)"
                    (click)="toggleExceptionDay(rowIndex, day.value)">
                    {{ day.label }}
                  </button>
                </div>
                <div class="exception-hint">{{setLabel('exceptionDaysHintLabel')}}</div>
              </div>

              <div class="exception-section">
                <label class="exception-field-label"
                  [ngClass]="{'zone-selection-warning': zoneSaveTouched && hasExceptionZoneSelectionError(rowIndex)}">
                  {{setLabel('exceptionZonesLabel')}}
                  <span class="required-star" *ngIf="areScheduleZonesRequired()">*</span>
                </label>
                <div class="day-chip-row exception-zones">
                  <button type="button" class="zone-chip zone-chip-schedule"
                    *ngFor="let zone of row.zones; let i = index"
                    [class.selected]="zone.IsSelect == 1"
                    (click)="updateExceptionZoneSelection(rowIndex, i, !(zone.IsSelect == 1))">
                    {{ zone.ZoneName }}
                  </button>
                </div>
                <div *ngIf="zoneSaveTouched && hasExceptionZoneSelectionError(rowIndex)" class="errorShow"
                  style="display: block; text-align: left;">
                  {{setLabel('selectAtLeastOneExceptionZoneErrorLabel')}}
                </div>
              </div>

              <div class="exception-live-desc">
                <div class="exception-live-desc-title">{{setLabel('accessWindowLiveDescTitleLabel')}}</div>
                <div class="exception-live-desc-text">{{ getAccessWindowLiveDescription(row) }}</div>
              </div>
            </div>

            <div class="add-exception-wrap">
              <button type="button" class="p-button p-widget p-state-default p-corner-all"
                (click)="addExceptionRow()">
                <span class="p-button-text p-c"><i class="fa fa-plus" aria-hidden="true"></i> {{setLabel('addExceptionBtnLabel')}}</span>
              </button>
            </div>
          </div>
        </div>
        <div style="clear: both;"></div>
      </div>

      <div class="nextBtn p-g-12">
        <button id="loginbtn" (click)="create(memberSignUpForm)"
          class="p-button p-widget p-state-default p-corner-all">
          <span class="p-button-text p-c">{{setLabel("saveBtnLabel")}}</span>
          <span *ngIf="loading" class="p-button-icon-left p-c fa fa-spinner fa-spin" style="font-size:24px"></span>
        </button>
      </div>

    </div>
    <div style="clear: both;"></div>
  </div>
  <div class="card card-w-title" *ngIf="activeIndex == 3">
    <div class="package-Builders p-g">
      <div class="p-g-12">
        <div class="card card-w-title" [ngClass]="{ 'loading': loading }">
          <p-tabView [activeIndex]="tabIndex" (onChange)="handleTabChange($event)">
              <p-table [value]="packages" [paginator]="true" [rows]="100" [responsive]="true" [loading]="loading"
                class="p-table-tecfolk-fix">
                <ng-template pTemplate="header">
                  <tr>
                    <th style="text-align: left; width: 6em;">{{setLabel("s.NLabel")}}</th>
                    <th style="text-align: left;">{{setLabel("packageNameLabel")}}</th>
                    <th style="text-align: left;">{{setLabel("packageTypeLabel")}}</th>
                    <th style="text-align: left;">{{setLabel("noOfMonthLabel")}}</th>
                    <th style="text-align: left;">{{setLabel("noOfMembersLabel")}}</th>
                    <th style="text-align: left;">{{setLabel("packageFeeLabel")}}</th>
                    <th style="text-align: left;">{{setLabel("registrationFeeLabel")}}</th>
                    <th style="text-align: left;">{{setLabel("actionLabel")}}</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData>
                  <ng-container *ngIf="rowData.isDelete == false">
                    <tr>
                      <td style="text-align: left;">
                        <div class="td-title">{{setLabel("s.NLabel")}}</div>
                        <span>{{rowData.sn}}</span>
                      </td>
                      <td style="text-align: left;">
                        <div class="td-title">{{setLabel("packageNameLabel")}}</div>
                        <span>{{rowData.packageName}}</span>
                      </td>
                      <td style="text-align: left; ">
                        <div class="td-title">{{setLabel("packageTypeLabel")}}</div>
                        <span>{{rowData.packageType}}</span>
                      </td>
                      <td style="text-align: left;">
                        <div class="td-title">{{setLabel("noOfMonthLabel")}}</div>
                        <span>{{rowData.noOfMonths}}</span>
                      </td>
                      <td style="text-align: left;">
                        <div class="td-title">{{setLabel("noOfMembersLabel")}}</div>
                        <span>{{rowData.noOfMembers}}</span>
                      </td>
                      <td style="text-align: left;">
                        <div class="td-title">{{setLabel("packageFeeLabel")}}</div>
                        <span>{{rowData.packageFee}}</span>
                      </td>
                      <td style="text-align: left;">
                        <div class="td-title">{{setLabel("registrationFeeLabel")}}</div>
                        <span>{{rowData.registerationFee}}</span>
                      </td>
                      <td style=" display: flex; padding-right: 2.2em;">
                        <div class="td-title">{{setLabel("actionLabel")}}</div>
                        &nbsp;
                        <button
                          style=" border-radius: 100% !important;align-items: center; width: 2.143em; height: 2.143em; display: flex;  justify-content: center;"
                          pButton type="button" pTooltip='Duplicate Package' tooltipPosition="top"
                          icon="fa fa-pencil-square-o" (click)="duplicatePackage(rowData)"></button>
                      </td>
                    </tr>
                  </ng-container>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-columns>
                  <tr>
                    <td>
                      {{setLabel("noRecordsFoundLabel")}}
                    </td>
                  </tr>
                </ng-template>
              </p-table>
          </p-tabView>
        </div>
      </div>
    </div>

    <div style="clear: both;"></div>
  </div>

</div>